import { render, staticRenderFns } from "./BulkImportPreview.vue?vue&type=template&id=5bf627e8&scoped=true"
import script from "./BulkImportPreview.vue?vue&type=script&lang=ts"
export * from "./BulkImportPreview.vue?vue&type=script&lang=ts"
import style0 from "./BulkImportPreview.vue?vue&type=style&index=0&id=5bf627e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf627e8",
  null
  
)

export default component.exports